import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getTipobolsa, postBolsa } from "../../../redux/actions";
import styles from "./Tipobolsa.module.css";

const TipoBolsa = () => {
  const [nombreBolsa, setNombreBolsa] = useState("");
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const bolsas = useSelector((state) => state.tipobolsa);
// console.log(bolsas)

  useEffect(() => {
    dispatch(getTipobolsa());
  }, [dispatch]);

  const handleCrearBolsa = async () => {
    if (nombreBolsa.trim() === "") {
      setError("El tipo de bolsa es obligatorio.");
      return;
    }

    try {
      await dispatch(postBolsa({ bolsa: nombreBolsa }));
      setNombreBolsa("");
      setError("");
      dispatch(getTipobolsa());

      Swal.fire({
        icon: "success",
        title: "Bolsa creada",
        text: "El tipo de bolsa fue creado con éxito",
        confirmButtonColor: "#3559d1"
      });

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.error || "Ocurrió un error al crear el tipo de bolsa"
      });
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.titulo}>Tipo de bolsas</h2>

      <input
        type="text"
        placeholder="Tipo bolsa"
        value={nombreBolsa}
        onChange={(e) => setNombreBolsa(e.target.value)}
        className={styles.input}
      />

      {error && <p className={styles.error}>{error}</p>}

      <button onClick={handleCrearBolsa} className={styles.boton}>
        Crear bolsa
      </button>

      <label className={styles.label}>Bolsas registradas:</label>
      <select className={styles.select}>
        {bolsas?.length > 0 ? (
          bolsas.map((b) => (
            <option key={b.id} value={b.bolsa}>
              {b.bolsa}
            </option>
          ))
        ) : (
          <option disabled>No hay bolsas registradas</option>
        )}
      </select>
    </div>
  );
};

export default TipoBolsa;
